export const ROLES = {
  SUPER_ADMIN: 'ROLE_SUPER_ADMIN',
  ADMIN: 'ROLE_ADMIN',
  USER: 'ROLE_USER',
} as const

export const SUPPORTED_TENANTS = ['persona', 'rtificial'] as const

export type TenantId = (typeof SUPPORTED_TENANTS)[number]
